import React from "react";
import { observer } from "mobx-react";
import * as changeCase from "change-case";

const ModalityOptions = observer((props) => {
    let sortedOptions = {};
    
    if(props?.modalityOptions && props?.modalityOptions === "object"){
        sortedOptions = Object.keys(props?.modalityOptions).sort();
    }
    
    return (
        <>
            {Object.entries(sortedOptions).length > 0 ? (
                <ul>
                    {sortedOptions.map((key) => (
                        <li key={key}>
                            {changeCase.capitalCase(key)}
                        </li>
                    ))}
            </ul>
            ) : (<>The options could not be retrieved for this session. Please check the enabled options assigned in the session in the proctoring interface.</>)}
        </>
    );
});

export default ModalityOptions;